import axios from "axios";
import { getAccessToken } from "helpers/Auth.helper";

const AUTH_API_URL = process.env.REACT_APP_AUTH_URL;
const languageCode = navigator.language;
const BASE_URL = `${AUTH_API_URL}/verification`;

const getAxios = () => {
    const headers: any = {
        accesskey: process.env.REACT_APP_AUTH_ACCESS_KEY,
        secretkey: process.env.REACT_APP_AUTH_SECRET_KEY,

        "language-code": languageCode,
    };

    const accessToken = getAccessToken();
    if (accessToken) {
        headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return axios.create({ headers });
};

export const checkExistsNicknameOfKoach = async (nickname: string) => {
    const url = `${BASE_URL}/koach/check/nickname`;
    return getAxios()
        .post(url, { nickname })
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
}

export const checkExistsHandlerOfKoach = async (handler: string) => {
    const url = `${BASE_URL}/koach/check/handler`;
    return getAxios()
        .post(url, { handler })
        .then(({ status, data }) => {
            return { status, data };
        })
        .catch(errorHandler);
}

const errorHandler = ({ response }: any) => {
    console.log(response);
    if (response?.status === 400) {
        throw new Error("Bad request");
    }

    if (response?.status === 401) {
        throw new Error("Authentication failed");
    }

    if (response?.status === 403) {
        throw new Error("Access denied");
    }

    if (response?.status === 404) {
        throw new Error("Resource not found");
    }

    if (response?.status >= 500) {
        throw new Error("Server error occurred");
    }

    throw new Error("Unknown error occurred");
};
